import { render } from "./Portfolio.vue?vue&type=template&id=0e9b6ac8&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=0e9b6ac8&lang=scss&scoped=true"

import exportComponent from "/Users/jorgecastanho/Documents/projects/Website-JCLda/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9b6ac8"]])

export default __exports__